<template>
  <div class="ShainToroku">
    <el-dialog title="社員情報" :visible="shainDialogVisible" @open="onOpen" @close="onClose" width="1300px" top="2vh">
      <el-form :model="form" id="shainjohoForm" label-width="120px" ref="shainjohoForm" v-loading="loading">
        <el-row>
          <el-col :span="7">
            <el-form-item label="社員ID">
              <el-input v-model="form.shainId" maxlength="50" :disabled="shainIdDisabled" autocomplete="off" placeholder=""></el-input>
              <div style="text-align:left;line-height:20px;margin-left:16px;">正社員はﾒｰﾙｱﾄﾞﾚｽ<br/>契約社員はAWSﾕｰｻﾞｰ名</div>
            </el-form-item>
            <el-form-item label="社員番号">
              <el-input v-model="form.shainBango" maxlength="5" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="社員氏名">
              <el-input v-model="form.shainShimei" maxlength="22" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="権限区分" prop="kengenKubun">
              <el-select v-model="form.kengenKubun">
                <el-option v-for="kubun in kengenKubuns" :key="kubun.value" :label="kubun.label" :value="kubun.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="社員区分" prop="shainKubun">
              <el-radio-group v-model="form.shainKubun" @change="onChangeKijun">
                <el-radio label="1">正社員</el-radio>
                <!--
                <el-radio label="2">契約社員(Office365ﾕｰｻﾞｰ)</el-radio>
                -->
                <el-radio label="3">契約社員(実働時間契約)</el-radio>
                <el-radio label="4">契約社員(基本時間契約)</el-radio>
                <el-radio label="5">嘱託社員A(実働時間契約)</el-radio>
                <el-radio label="6">嘱託社員A(基本時間契約)</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="拠点" prop="kyotenCd">
              <el-select v-model="form.kyotenCd">
                <el-option v-for="cd in kyotenCds" :key="cd.value" :label="cd.label" :value="cd.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="退職日" prop="taishokuBi">
              <el-date-picker v-model="form.taishokuBi" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="基準始業･終業時刻" label-width="140px" :error="errors.kijunJikoku">
              <el-input v-model="form.kijunShigyoJikoku" type="time" class="time-input" @change="onChangeKijun"></el-input>
              <el-input v-model="form.kijunShugyoJikoku" type="time" class="time-input" @change="onChangeKijun"></el-input>
            </el-form-item>
            <el-form-item label="昼食開始･終了時刻" label-width="140px">
              <el-input v-model="form.chushokuKaishiJikoku" type="time" class="time-input" @change="onChangeKijun"></el-input>
              <el-input v-model="form.chushokuShuryoJikoku" type="time" class="time-input" @change="onChangeKijun"></el-input>
            </el-form-item>
            <el-form-item label="休憩開始･終了時刻" label-width="140px">
              <el-input v-model="form.kyukeiKaishiJikoku" type="time" class="time-input"></el-input>
              <el-input v-model="form.kyukeiShuryoJikoku" type="time" class="time-input"></el-input>
            </el-form-item>
            <el-form-item label="実働契約時間" label-width="140px">
              <el-input v-model="form.jitsudoKeiyakuJikan" maxlength="4" class="number-input" :disabled="form.shainKubun != '3' && form.shainKubun != '5'" readonly></el-input> H
              <div style="line-height:24px;">※基準時刻から自動計算</div>
            </el-form-item>
            <el-form-item label="基本契約時間" label-width="140px">
              <el-input v-model="form.kihonKeiyakuJikanFrom" maxlength="3" class="number-input" :disabled="form.shainKubun != '4' && form.shainKubun != '6'"></el-input> H ～ 
              <el-input v-model="form.kihonKeiyakuJikanTo" maxlength="3" class="number-input" :disabled="form.shainKubun != '4' && form.shainKubun != '6'"></el-input> H
            </el-form-item>
            <el-form-item label="上長ﾒｰﾙｱﾄﾞﾚｽ1" label-width="140px" :error="errors.jochoShainId">
              <el-input v-model="form.jochoShainId" maxlength="50" autocomplete="off" :disabled="!isGenechMailUser(form.shainId)"></el-input>
            </el-form-item>
            <el-form-item label="上長ﾒｰﾙｱﾄﾞﾚｽ2" label-width="140px" :error="errors.jochoShainId2">
              <el-input v-model="form.jochoShainId2" maxlength="50" autocomplete="off" :disabled="!isGenechMailUser(form.shainId)"></el-input>
            </el-form-item>
            <el-form-item label="上長ﾒｰﾙｱﾄﾞﾚｽ3" label-width="140px" :error="errors.jochoShainId3">
              <el-input v-model="form.jochoShainId3" maxlength="50" autocomplete="off" :disabled="!isGenechMailUser(form.shainId)"></el-input>
            </el-form-item>
            <el-form-item label="営業ﾒｰﾙｱﾄﾞﾚｽ1" label-width="140px" :error="errors.eigyoShainId">
              <el-input v-model="form.eigyoShainId" maxlength="50" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="営業ﾒｰﾙｱﾄﾞﾚｽ2" label-width="140px" :error="errors.eigyoShainId2">
              <el-input v-model="form.eigyoShainId2" maxlength="50" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="営業ﾒｰﾙｱﾄﾞﾚｽ3" label-width="140px" :error="errors.eigyoShainId3">
              <el-input v-model="form.eigyoShainId3" maxlength="50" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="残業承認者" prop="zangyoShoninshaSei">
              <el-input v-model="form.zangyoShoninshaSei" maxlength="10" placeholder="姓" class="half-input" :disabled="!isGenechMailUser(form.shainId)"></el-input>
              <el-input v-model="form.zangyoShoninshaMei" maxlength="10" placeholder="名" class="half-input" :disabled="!isGenechMailUser(form.shainId)"></el-input>
            </el-form-item>
            <el-form-item label="定期代" prop="teikiHitsuyoFlag">
              <el-checkbox v-model="form.teikiHitsuyoFlag" label="必要" :border="true" class="teiki-input"></el-checkbox>
            </el-form-item>
            <el-form-item label="通勤経路1" prop="kotsuKikanMei1">
              <el-input v-model="form.kotsuKikanMei1" maxlength="20" placeholder="交通機関名" class="kotsu-input"></el-input>
              <el-input v-model="form.tsukinRoute1" maxlength="30" placeholder="通勤ルート" class="route-input"></el-input>
              <el-input v-model="form.tsukinKotsuhi1" maxlength="6" placeholder="往復金額" class="tsukin-input"></el-input>
            </el-form-item>
            <div>
              <el-form-item label="通勤経路2" prop="kotsuKikanMei2">
                <el-input v-model="form.kotsuKikanMei2" maxlength="20" placeholder="交通機関名" class="kotsu-input"></el-input>
                <el-input v-model="form.tsukinRoute2" maxlength="30" placeholder="通勤ルート" class="route-input"></el-input>
                <el-input v-model="form.tsukinKotsuhi2" maxlength="6" placeholder="往復金額" class="tsukin-input"></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="通勤経路3" prop="kotsuKikanMei3">
                <el-input v-model="form.kotsuKikanMei3" maxlength="20" placeholder="交通機関名" class="kotsu-input"></el-input>
                <el-input v-model="form.tsukinRoute3" maxlength="30" placeholder="通勤ルート" class="route-input"></el-input>
                <el-input v-model="form.tsukinKotsuhi3" maxlength="6" placeholder="往復金額" class="tsukin-input"></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="通勤経路4" prop="kotsuKikanMei4">
                <el-input v-model="form.kotsuKikanMei4" maxlength="20" placeholder="交通機関名" class="kotsu-input"></el-input>
                <el-input v-model="form.tsukinRoute4" maxlength="30" placeholder="通勤ルート" class="route-input"></el-input>
                <el-input v-model="form.tsukinKotsuhi4" maxlength="6" placeholder="往復金額" class="tsukin-input"></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="通勤経路5" prop="kotsuKikanMei5">
                <el-input v-model="form.kotsuKikanMei5" maxlength="20" placeholder="交通機関名" class="kotsu-input"></el-input>
                <el-input v-model="form.tsukinRoute5" maxlength="30" placeholder="通勤ルート" class="route-input"></el-input>
                <el-input v-model="form.tsukinKotsuhi5" maxlength="6" placeholder="往復金額" class="tsukin-input"></el-input>
              </el-form-item>
            </div>
            <el-form-item label="安否ﾒｰﾙｱﾄﾞﾚｽ1" :error="errors.bcpCompanyEmail">
              <el-input v-model="form.bcpCompanyEmail" maxlength="128" autocomplete="off" class="teiki-input" :disabled="isGenechMailUser(form.shainId)"></el-input>
            </el-form-item>
            <el-form-item label="安否ﾒｰﾙｱﾄﾞﾚｽ2" :error="errors.bcpPrivateEmail">
              <el-input v-model="form.bcpPrivateEmail" maxlength="128" autocomplete="off" class="teiki-input" :disabled="isGenechMailUser(form.shainId)"></el-input>
            </el-form-item>
            <el-form-item label="安否電話番号" :error="errors.bcpPrivatePhone">
              <el-input v-model="form.bcpPrivatePhone" maxlength="13" autocomplete="off" class="teiki-input" :disabled="isGenechMailUser(form.shainId)"></el-input>
              <div style="line-height: 20px;text-align: left;">※ハイフンなしで入力</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="canDelete" @click="onDelete" style="float: left;">削除</el-button>
        <el-button @click="onClose">キャンセル</el-button>
        <el-button type="primary" @click="onRegister('shainjohoForm')">登録</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { notifySuccess, notifyError } from '../utils.js'

export default {
  name: 'ShainToroku',
  props: ['shainDialogVisible', 'shain'],
  data() {
    return {
      form: {
        shainId: '',
        shainBango: '',
        shainShimei: '',
        kengenKubun: '',
        shainKubun: '1',
        kijunShigyoJikoku: '',
        kijunShugyoJikoku: '',
        chushokuKaishiJikoku: '',
        chushokuShuryoJikoku: '',
        kyukeiKaishiJikoku: '',
        kyukeiShuryoJikoku: '',
        jitsudoKeiyakuJikan: '',
        kihonKeiyakuJikanFrom: '',
        kihonKeiyakuJikanTo: '',
        jochoShainId: '',
        jochoShainId2: '',
        jochoShainId3: '',
        eigyoShainId: '',
        eigyoShainId2: '',
        eigyoShainId3: '',
        taishokuBi: '',
        canDeleteFlag: '',
        kyotenCd: 'JP',
        zangyoShoninshaSei: '',
        zangyoShoninshaMei: '',
        teikiHitsuyoFlag: false,
        kotsuKikanMei1: '',
        tsukinRoute1: '',
        tsukinKotsuhi1: 0,
        kotsuKikanMei2: '',
        tsukinRoute2: '',
        tsukinKotsuhi2: 0,
        kotsuKikanMei3: '',
        tsukinRoute3: '',
        tsukinKotsuhi3: 0,
        kotsuKikanMei4: '',
        tsukinRoute4: '',
        tsukinKotsuhi4: 0,
        kotsuKikanMei5: '',
        tsukinRoute5: '',
        tsukinKotsuhi5: 0,
        bcpCompanyEmail: '',
        bcpPrivateEmail: '',
        bcpPrivatePhone: '',
      },
      errors: {
        kijunJikoku: '',
        jochoShainId: '',
        jochoShainId2: '',
        jochoShainId3: '',
        eigyoShainId: '',
        eigyoShainId2: '',
        eigyoShainId3: '',
      },
      kengenKubuns: [
        {value: '100', label: '一般社員'},
        {value: '200', label: 'パイロットユーザー'},
        {value: '500', label: '週報閲覧者'},
        {value: '700', label: '労務担当者'},
        {value: '900', label: 'システム管理者'},
      ],
      kyotenCds: [
        {value: 'JP', label: '日本'},
        {value: 'TH', label: 'タイ'},
      ],
      shainIdDisabled: true,
      loading: true
    }
  },
  computed: {
    canDelete() {
      return this.form.canDeleteFlag && this.shainIdDisabled;
    },
  },
  methods: {
    isGenechMailUser(shainId) {
      return this.$parent.$parent.isGenechMailUser(shainId);
    },
    onOpen() {
      this.errors = {
        kijunJikoku: '',
        jochoShainId: '',
        jochoShainId2: '',
        jochoShainId3: '',
        eigyoShainId: '',
        eigyoShainId2: '',
        eigyoShainId3: '',
      };
      if (this.shain == null) {
        this.shainIdDisabled = false;
        this.form.shainId = '';
        this.form.shainBango = '';
        this.form.shainShimei = '';
        this.form.kengenKubun = '100';
        this.form.shainKubun = '1';
        this.form.kyotenCd = 'JP';
        this.form.kijunShigyoJikoku = '';
        this.form.kijunShugyoJikoku = '';
        this.form.chushokuKaishiJikoku = '';
        this.form.chushokuShuryoJikoku = '';
        this.form.kyukeiKaishiJikoku = '';
        this.form.kyukeiShuryoJikoku = '';
        this.form.jitsudoKeiyakuJikan = '';
        this.form.kihonKeiyakuJikanFrom = '';
        this.form.kihonKeiyakuJikanTo = '';
        this.form.jochoShainId = '';
        this.form.jochoShainId2 = '';
        this.form.jochoShainId3 = '';
        this.form.eigyoShainId = '';
        this.form.eigyoShainId2 = '';
        this.form.eigyoShainId3 = '';
        this.form.taishokuBi = '';
        this.form.zangyoShoninshaSei = '';
        this.form.zangyoShoninshaMei = '';
        this.form.teikiHitsuyoFlag = false;
        this.form.kotsuKikanMei1 = '';
        this.form.tsukinRoute1 = '';
        this.form.tsukinKotsuhi1 = '';
        this.form.kotsuKikanMei2 = '';
        this.form.tsukinRoute2 = '';
        this.form.tsukinKotsuhi2 = '';
        this.form.kotsuKikanMei3 = '';
        this.form.tsukinRoute3 = '';
        this.form.tsukinKotsuhi3 = '';
        this.form.kotsuKikanMei4 = '';
        this.form.tsukinRoute4 = '';
        this.form.tsukinKotsuhi4 = '';
        this.form.kotsuKikanMei5 = '';
        this.form.tsukinRoute5 = '';
        this.form.tsukinKotsuhi5 = '';
        this.form.bcpCompanyEmail = '';
        this.form.bcpPrivateEmail = '';
        this.form.bcpPrivatePhone = '';
        this.form.canDeleteFlag = true;
        this.targetRow = null;
        this.loading = false;
      } else {
        this.loading = true;
        this.shainIdDisabled = true;
        this.$axios.get('/gwr/shain/shain/' + this.shain.shainId)
          .then((response) => {
            this.form.shainId = response.data.shainId;
            this.form.shainBango = response.data.shainBango;
            this.form.shainShimei = response.data.shainShimei;
            this.form.kengenKubun = response.data.kengenKubun;
            this.form.shainKubun = response.data.shainKubun;
            this.form.kyotenCd = response.data.kyotenCd;
            this.form.kijunShigyoJikoku = response.data.kijunShigyoJikoku;
            this.form.kijunShugyoJikoku = response.data.kijunShugyoJikoku;
            this.form.chushokuKaishiJikoku = response.data.chushokuKaishiJikoku;
            this.form.chushokuShuryoJikoku = response.data.chushokuShuryoJikoku;
            this.form.kyukeiKaishiJikoku = response.data.kyukeiKaishiJikoku;
            this.form.kyukeiShuryoJikoku = response.data.kyukeiShuryoJikoku;
            this.form.jitsudoKeiyakuJikan = response.data.jitsudoKeiyakuJikan;
            this.form.kihonKeiyakuJikanFrom = response.data.kihonKeiyakuJikanFrom;
            this.form.kihonKeiyakuJikanTo = response.data.kihonKeiyakuJikanTo;
            this.form.jochoShainId = response.data.jochoShainId;
            this.form.jochoShainId2 = response.data.jochoShainId2;
            this.form.jochoShainId3 = response.data.jochoShainId3;
            this.form.eigyoShainId = response.data.eigyoShainId;
            this.form.eigyoShainId2 = response.data.eigyoShainId2;
            this.form.eigyoShainId3 = response.data.eigyoShainId3;
            if (response.data.taishokuBi != null && response.data.taishokuBi != '') {
              this.form.taishokuBi = new Date(this.$moment(response.data.taishokuBi).format('YYYY-MM-DD'));
            } else {
              this.form.taishokuBi = '';
            }
            this.form.zangyoShoninshaSei = response.data.zangyoShoninshaSei;
            this.form.zangyoShoninshaMei = response.data.zangyoShoninshaMei;
            this.form.teikiHitsuyoFlag = response.data.teikiHitsuyoFlag;
            this.form.kotsuKikanMei1 = response.data.kotsuKikanMei1;
            this.form.tsukinRoute1 = response.data.tsukinRoute1;
            this.form.tsukinKotsuhi1 = response.data.tsukinKotsuhi1;
            this.form.kotsuKikanMei2 = response.data.kotsuKikanMei2;
            this.form.tsukinRoute2 = response.data.tsukinRoute2;
            this.form.tsukinKotsuhi2 = response.data.tsukinKotsuhi2;
            this.form.kotsuKikanMei3 = response.data.kotsuKikanMei3;
            this.form.tsukinRoute3 = response.data.tsukinRoute3;
            this.form.tsukinKotsuhi3 = response.data.tsukinKotsuhi3;
            this.form.kotsuKikanMei4 = response.data.kotsuKikanMei4;
            this.form.tsukinRoute4 = response.data.tsukinRoute4;
            this.form.tsukinKotsuhi4 = response.data.tsukinKotsuhi4;
            this.form.kotsuKikanMei5 = response.data.kotsuKikanMei5;
            this.form.tsukinRoute5 = response.data.tsukinRoute5;
            this.form.tsukinKotsuhi5 = response.data.tsukinKotsuhi5;
            this.form.bcpCompanyEmail = response.data.bcpCompanyEmail;
            this.form.bcpPrivateEmail = response.data.bcpPrivateEmail;
            this.form.bcpPrivatePhone = response.data.bcpPrivatePhone;
            this.form.canDeleteFlag = response.data.canDeleteFlag;
            this.targetRow = this.shain;
            this.loading = false;
          })
          .catch((error) => {
            notifyError(this, error, 'データ取得エラー');
          });
      }
    },
    onChangeKijun() {
      if ((this.form.shainKubun != '3' && this.form.shainKubun != '5') || !this.form.kijunShigyoJikoku || !this.form.kijunShugyoJikoku) {
        this.form.jitsudoKeiyakuJikan = '';
        return;
      }
      const dateSrting = '2000/01/01 ';
      const kijunShigyoJikoku = this.$moment(dateSrting + this.form.kijunShigyoJikoku);
      const kijunShugyoJikoku = this.$moment(dateSrting + this.form.kijunShugyoJikoku);
      const rodoJikan = kijunShugyoJikoku.diff(kijunShigyoJikoku, 'hours', true);
      const chushokuKaishiJikoku = this.$moment(dateSrting + this.form.chushokuKaishiJikoku);
      const chushokuShuryoJikoku = this.$moment(dateSrting + this.form.chushokuShuryoJikoku);
      let chusyokuJikan = 0;
      if (chushokuKaishiJikoku.isValid() && chushokuShuryoJikoku.isValid()) {
        chusyokuJikan = chushokuShuryoJikoku.diff(chushokuKaishiJikoku, 'hours', true);
      }
      this.form.jitsudoKeiyakuJikan = Math.round((rodoJikan - chusyokuJikan) * 100) / 100;
    },
    validateJocho: async function(shainId) {
      let result = false;
      this.loading = true;
      try {
        let response = await this.$axios.get('/gwr/shain/validateJocho/' + shainId)
        result = response.data;
      }
      catch (error) {
        notifyError(this, error, 'データ取得エラー');
      }
      this.loading = false;
      return result;
    },
    onRegister(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.errors = {
            kijunJikoku: '',
            jochoShainId: '',
            jochoShainId2: '',
            jochoShainId3: '',
            eigyoShainId: '',
            eigyoShainId2: '',
            eigyoShainId3: '',
          }
          let hasError = false;
          if (!this.form.kijunShigyoJikoku || !this.form.kijunShugyoJikoku) {
            this.errors.kijunJikoku = '基準始業･終業時刻を入力してください。';
            hasError = true;
          }
          if (this.form.jochoShainId && !(await this.validateJocho(this.form.jochoShainId))) {
            this.errors.jochoShainId = '登録されていないアドレスです。';
            hasError = true;
          }
          if (this.form.jochoShainId2 && !(await this.validateJocho(this.form.jochoShainId2))) {
            this.errors.jochoShainId2 = '登録されていないアドレスです。';
            hasError = true;
          }
          if (this.form.jochoShainId3 && !(await this.validateJocho(this.form.jochoShainId3))) {
            this.errors.jochoShainId3 = '登録されていないアドレスです。';
            hasError = true;
          }
          if (this.form.eigyoShainId && !(await this.validateJocho(this.form.eigyoShainId))) {
            this.errors.eigyoShainId = '登録されていないアドレスです。';
            hasError = true;
          }
          if (this.form.eigyoShainId2 && !(await this.validateJocho(this.form.eigyoShainId2))) {
            this.errors.eigyoShainId2 = '登録されていないアドレスです。';
            hasError = true;
          }
          if (this.form.eigyoShainId3 && !(await this.validateJocho(this.form.eigyoShainId3))) {
            this.errors.eigyoShainId3 = '登録されていないアドレスです。';
            hasError = true;
          }
          if (hasError) {
            this.$notify({
              title: '入力エラー',
              message: '入力欄に表示されているエラー内容を確認してください。',
              type: 'error'
            });
            return;
          }
          this.loading = true;
          let params = new URLSearchParams();
          params.append('shainId', this.form.shainId ?? '');
          params.append('shainBango', this.form.shainBango ?? '');
          params.append('shainShimei', this.form.shainShimei ?? '');
          params.append('kengenKubun', this.form.kengenKubun ?? '');
          params.append('shainKubun', this.form.shainKubun ?? '');
          params.append('kyotenCd', this.form.kyotenCd ?? '');
          params.append('kijunShigyoJikoku', this.form.kijunShigyoJikoku ?? '');
          params.append('kijunShugyoJikoku', this.form.kijunShugyoJikoku ?? '');
          params.append('chushokuKaishiJikoku', this.form.chushokuKaishiJikoku ?? '');
          params.append('chushokuShuryoJikoku', this.form.chushokuShuryoJikoku ?? '');
          params.append('kyukeiKaishiJikoku', this.form.kyukeiKaishiJikoku ?? '');
          params.append('kyukeiShuryoJikoku', this.form.kyukeiShuryoJikoku ?? '');
          params.append('jitsudoKeiyakuJikan', this.form.jitsudoKeiyakuJikan ?? '');
          params.append('kihonKeiyakuJikanFrom', this.form.kihonKeiyakuJikanFrom ?? '');
          params.append('kihonKeiyakuJikanTo', this.form.kihonKeiyakuJikanTo ?? '');
          params.append('jochoShainId', this.form.jochoShainId ?? '');
          params.append('jochoShainId2', this.form.jochoShainId2 ?? '');
          params.append('jochoShainId3', this.form.jochoShainId3 ?? '');
          params.append('eigyoShainId', this.form.eigyoShainId ?? '');
          params.append('eigyoShainId2', this.form.eigyoShainId2 ?? '');
          params.append('eigyoShainId3', this.form.eigyoShainId3 ?? '');
          params.append('taishokuBi', this.form.taishokuBi ?? '');
          params.append('zangyoShoninshaSei', this.form.zangyoShoninshaSei ?? '');
          params.append('zangyoShoninshaMei', this.form.zangyoShoninshaMei ?? '');
          params.append('teikiHitsuyoFlag', this.form.teikiHitsuyoFlag ?? false);
          params.append('kotsuKikanMei1', this.form.kotsuKikanMei1 ?? '');
          params.append('tsukinRoute1', this.form.tsukinRoute1 ?? '');
          params.append('tsukinKotsuhi1', this.form.tsukinKotsuhi1 ?? '');
          params.append('kotsuKikanMei2', this.form.kotsuKikanMei2 ?? '');
          params.append('tsukinRoute2', this.form.tsukinRoute2 ?? '');
          params.append('tsukinKotsuhi2', this.form.tsukinKotsuhi2 ?? '');
          params.append('kotsuKikanMei3', this.form.kotsuKikanMei3 ?? '');
          params.append('tsukinRoute3', this.form.tsukinRoute3 ?? '');
          params.append('tsukinKotsuhi3', this.form.tsukinKotsuhi3 ?? '');
          params.append('kotsuKikanMei4', this.form.kotsuKikanMei4 ?? '');
          params.append('tsukinRoute4', this.form.tsukinRoute4 ?? '');
          params.append('tsukinKotsuhi4', this.form.tsukinKotsuhi4 ?? '');
          params.append('kotsuKikanMei5', this.form.kotsuKikanMei5 ?? '');
          params.append('tsukinRoute5', this.form.tsukinRoute5 ?? '');
          params.append('tsukinKotsuhi5', this.form.tsukinKotsuhi5 ?? '');
          params.append('bcpCompanyEmail', this.form.bcpCompanyEmail ?? '');
          params.append('bcpPrivateEmail', this.form.bcpPrivateEmail ?? '');
          params.append('bcpPrivatePhone', this.form.bcpPrivatePhone ?? '');
          params.append('canDeleteFlag', this.form.canDeleteFlag ?? true);
          this.$axios.post('/gwr/shain/shainJoho', params)
              .then(() => {
                notifySuccess(this, '登録完了', '社員情報を登録しました。');
              })
              .catch((error) => {
                notifyError(this, error, 'データ登録エラー');
              });
          this.onClose();
        } else {
          return false;
        }
      });
    },
    onDelete() {
      this.$confirm('社員情報を完全に削除します。よろしいですか？', '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        type: 'info'
      }).then(() => {
        this.loading = true;
        this.$axios.delete('/gwr/shain/shainJoho/' + this.form.shainId)
          .then(() => {
            notifySuccess(this, '削除完了', '社員情報を削除しました。');
            this.onClose();
          })
          .catch((error) => {
            notifyError(this, error, '削除エラー');
          });
      });
    },
    onClose() {
      this.$emit('close-shain-dialog');
    }
  }
}
</script>

<style scoped>
#shainjohoForm >>> .el-input {
  width: 220px !important;
}
.el-button {
  margin: 0px 1px !important;
}
#shainjohoForm >>> .time-input {
  width: 110px !important;
}
#shainjohoForm >>> .half-input {
  width: 200px !important;
}
#shainjohoForm >>> .number-input {
  width: 84px !important;
  text-align: left;
}
#shainjohoForm >>> .teiki-input {
  width: 400px !important;
  text-align: left;
}
#shainjohoForm >>> .kotsu-input {
  width: 130px !important;
}
#shainjohoForm >>> .route-input {
  width: 180px !important;
}
#shainjohoForm >>> .tsukin-input {
  width: 90px !important;
  float: right;
}
#shainjohoForm >>> .el-input__inner {
  font-family: inherit !important;
}
#shainjohoForm >>> .el-radio-group {
  text-align: left;
  line-height: 20px;
  padding-left: 20px;
}
.ShainToroku >>> .el-dialog__body {
  padding-top: 10px !important;
  padding-bottom: 0 !important;
}
.ShainToroku >>> .el-dialog__footer {
  margin-top: -10px !important;
}
</style>